





































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputPrice from "@/encoding/components/buildingBlocks/InputPrice.vue";
import { ClassifiedDeactivationReason, Reason } from "@/shared/interfaces/ClassifiedDeactivationReason.interface";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwInputPrice: iwInputPrice,
    },

    props: {
        selected: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data: function() {
        return {
            specificId: uuidv4() as string,
            price: 0,
        };
    },

    computed: {
        errorMessage: function(): string {
            if (this.$store.getters["MyClassifiedsModule/hasClassifiedApiError"]("price")) {
                return this.$t("classified_deactivation_reason_price_error") as string;
            }

            return "";
        },
    },

    methods: {
        emitUpdate: function() {
            let reason: ClassifiedDeactivationReason = {
                type: "SOLD_OR_RENTED" as unknown as Reason,
            };

            // `price` can't be sent to the API if not provided by the user
            if (this.price >= 0) {
                reason.price = this.price;
            }

            this.$emit("update", reason);
        },

        updatePrice: function(amount: number) {
            this.price = amount;
            this.emitUpdate();
        },
    },
});
